module.exports = __webpack_public_path__ + "static/media/TS.471bb4f7.webp";